function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as _, jsx as r, Fragment as Ne } from "react/jsx-runtime";
import * as o from "react";
import ee from "classnames";
import { useForm as Re } from "./form-context.js";
import { useAriaId as Ae, useTheme as ke, useScreenSize as _e } from "./hooks.js";
import { TAB as be, ESC as Pe, ENTER as te, SPACE as ne, UP as Ve, DOWN as De } from "./utils/key-codes.js";
import { FieldContainer as Me, HelperText as He, Label as Fe } from "./text-field-components.js";
import oe from "./generated/mistica-icons/icon-chevron-down-regular.js";
import { TextFieldBaseAutosuggest as Ge } from "./text-field-base.js";
import Ze from "./overlay.js";
import { isAndroid as Be, isIos as We } from "./utils/platform.js";
import { cancelEvent as h } from "./utils/dom.js";
import { Text3 as Le } from "./text.js";
import { selectVariants as $e, arrowDown as qe, selectContainerVariants as ze, selectTextVariants as je, vars as C, optionsContainer as Ke, optionsAnimationsVariants as se, menuItem as Ue, menuItemSelected as Xe } from "./select.css-mistica.js";
import { assignInlineVars as Je } from "@vanilla-extract/dynamic";
import { Portal as Qe } from "./portal.js";
const Ye = (param)=>{
    let { id: re , label: d , helperText: ie , value: ce , onChangeValue: b , name: i , fullWidth: P , options: u , optional: V , disabled: le , error: ae , onBlur: D , autoFocus: $ = !1 , native: ue  } = param;
    var Y;
    const S = o.useRef(null), f = o.useRef(null), g = o.useRef(null), T = o.useRef(null), N = o.useRef(/* @__PURE__ */ new Map()), [de, fe] = o.useState(!0), [p, pe] = o.useState(), [M, q] = o.useState(!1), [z, j] = o.useState(!1), [K, x] = o.useState(!1), [a, H] = o.useState({}), [v, F] = o.useState(), G = o.useRef(null), Z = Ae(re), { rawValues: me , setRawValue: B , setValue: W , formStatus: he , formErrors: U , setFormError: Se , register: L  } = Re(), { platformOverrides: X  } = ke(), ge = ue || process.env.NODE_ENV === "test" && !process.env.SSR_TEST || Be(X) || We(X), I = le || he === "sending", R = ae || !!U[i], J = U[i] || ie, l = ce !== null && ce !== void 0 ? ce : me[i], A = (e)=>{
        b == null || b(e), Se({
            name: i,
            error: ""
        }), B({
            name: i,
            value: e
        }), W({
            name: i,
            value: e
        });
    }, E = (e)=>{
        if (e) {
            if (g != null && g.current) {
                const s = g.current.getBoundingClientRect(), m = s.top, w = s.width, O = s.left, Oe = s.height, y = m + Oe, k = Math.min(u.length, 8) * 48 + 16;
                if (y + k + 12 > window.innerHeight) {
                    const ye = window.innerHeight - y;
                    if (m > ye) {
                        const Ce = m - k;
                        H({
                            minWidth: w,
                            left: O,
                            top: Math.max(Ce, 12),
                            maxHeight: Math.min(m - 12, k),
                            transformOrigin: "center bottom"
                        });
                    } else H({
                        minWidth: w,
                        top: y,
                        left: O,
                        maxHeight: window.innerHeight - y - 12,
                        transformOrigin: "center top"
                    });
                } else H({
                    minWidth: w,
                    top: y,
                    left: O,
                    maxHeight: k,
                    transformOrigin: "center top"
                });
            }
            q(!0), requestAnimationFrame(()=>{
                G.current && T.current && "scrollTop" in T.current && (T.current.scrollTop = G.current), j(!0);
            }), F(p !== null && p !== void 0 ? p : l);
        } else j(!1), q(!1), F(void 0);
    }, Q = (e)=>{
        var t;
        G.current = (t = T.current) == null ? void 0 : t.scrollTop, E(!1), A && typeof e == "string" && A(e), typeof l > "u" && pe(e);
    }, Te = (e)=>{
        var n;
        const t = (n = T.current) == null ? void 0 : n.getBoundingClientRect();
        if (t && e && N.current.has(e)) {
            const c = N.current.get(e), s = c == null ? void 0 : c.getBoundingClientRect();
            if (s && s.top + s.height / 2 >= t.top + t.height) {
                c == null || c.scrollIntoView();
                return;
            }
            s && s.top + s.height / 2 <= t.top && (c == null || c.scrollIntoView(!1));
        }
    }, ve = f.current, Ie = S.current;
    o.useEffect(()=>{
        B({
            name: i,
            value: l
        }), W({
            name: i,
            value: l
        });
    }, [
        i,
        B,
        W,
        l
    ]), o.useEffect(()=>(L(i, {
            input: S.current,
            focusableElement: f.current
        }), ()=>{
            L(i, {
                input: null,
                focusableElement: null
            });
        }), [
        i,
        L,
        f,
        S,
        ve,
        Ie
    ]), o.useEffect(()=>{
        const e = (n)=>{
            var m;
            const s = {
                [Ve]: -1,
                [De]: 1
            }[n.keyCode];
            if (s) {
                h(n);
                var _ref;
                const w = (_ref = (m = u[u.findIndex((param)=>{
                    let { value: O  } = param;
                    return O === v;
                }) + s]) == null ? void 0 : m.value) !== null && _ref !== void 0 ? _ref : v;
                F(w), Te(w);
            }
        }, t = (n)=>{
            M && (n.keyCode === be && h(n), n.keyCode === Pe && E(!1), (n.keyCode === te || n.keyCode === ne) && (h(n), u.findIndex((param)=>{
                let { value: c  } = param;
                return c === v;
            }) !== -1 && v !== p && Q(v), E(!1))), z && e(n);
        };
        return document.addEventListener("keydown", t, !1), ()=>{
            document.removeEventListener("keydown", t, !1);
        };
    }), o.useEffect(()=>{
        $ && f.current && f.current.focus();
    }, [
        $
    ]), o.useEffect(()=>{
        fe(!1);
    }, []);
    const Ee = (e)=>{
        var t;
        return e ? (t = u.find((param)=>{
            let { value: n  } = param;
            return n === e;
        })) == null ? void 0 : t.text : "";
    }, we = {
        tabIndex: 0,
        onFocus: ()=>x(!0),
        onBlur: ()=>x(!1),
        onClick: ()=>{
            E(!0), x(!0);
        },
        onKeyDown: (e)=>{
            !M && (e.keyCode === ne || e.keyCode === te) && (h(e), E(!0));
        }
    }, { isDesktopOrBigger: xe  } = _e();
    var _ref, _a_transformOrigin;
    return ge || de ? /* @__PURE__ */ _(Me, {
        disabled: I,
        helperText: /* @__PURE__ */ r(He, {
            error: R,
            leftText: J
        }),
        fieldRef: g,
        fullWidth: P,
        children: [
            d && /* @__PURE__ */ r(Fe, {
                error: R,
                forId: Z,
                inputState: K ? "focused" : ((_ref = l !== null && l !== void 0 ? l : p) !== null && _ref !== void 0 ? _ref : (Y = S.current) == null ? void 0 : Y.value) ? "filled" : "default",
                optional: V,
                children: d
            }),
            /* @__PURE__ */ _("select", {
                className: $e[I ? "disabled" : "default"],
                id: Z,
                "aria-invalid": !!R,
                value: l,
                required: !V,
                disabled: I,
                onChange: (e)=>{
                    A && A(e.target.value);
                },
                onFocus: ()=>x(!0),
                onBlur: (e)=>{
                    x(!1), D == null || D(e);
                },
                ref: (e)=>{
                    [
                        S,
                        f
                    ].forEach((t)=>{
                        t.current = e;
                    });
                },
                style: {
                    paddingTop: d ? 24 : 16,
                    paddingBottom: d ? 8 : 16,
                    paddingRight: 48,
                    // Override default browser opacity when disabled. This opacity also affects the label.
                    // Without this fix, the label is invisible when disabled
                    opacity: 1
                },
                children: [
                    u.every((param)=>{
                        let { value: e  } = param;
                        return !!e;
                    }) && // if no "empty" option exists, insert a dummy empty option
                    // this is needed to allow a native select with no selected option
                    /* @__PURE__ */ r("option", {
                        value: "",
                        style: {
                            display: "none"
                        }
                    }),
                    u.map((param)=>/* @__PURE__ */ {
                        let { value: e , text: t  } = param;
                        return r("option", {
                            value: e,
                            children: t
                        }, e);
                    })
                ]
            }),
            /* @__PURE__ */ r("div", {
                className: qe,
                "aria-hidden": !0,
                children: /* @__PURE__ */ r(oe, {
                    size: 20
                })
            })
        ]
    }) : /* @__PURE__ */ _(Ne, {
        children: [
            /* @__PURE__ */ _("div", _object_spread_props(_object_spread({
                className: ze[P ? "fullWidth" : "default"],
                role: "button",
                "aria-haspopup": "listbox",
                ref: f
            }, !I && we), {
                children: [
                    /* @__PURE__ */ r(Ge, {
                        style: {
                            visibility: "hidden"
                        },
                        fullWidth: P,
                        endIcon: /* @__PURE__ */ r(oe, {
                            size: 20
                        }),
                        focus: K,
                        label: d,
                        value: l,
                        shrinkLabel: !!(l || p),
                        name: i,
                        helperText: J,
                        required: !V,
                        disabled: I,
                        id: Z,
                        error: R,
                        inputRef: S,
                        fieldRef: g
                    }),
                    /* @__PURE__ */ r("div", {
                        className: je[I ? "disabled" : "default"],
                        style: {
                            top: xe ? d ? 28 : 18 : d ? 25 : 16
                        },
                        children: Ee(l !== null && l !== void 0 ? l : p)
                    })
                ]
            })),
            M && /* @__PURE__ */ r(Ze, {
                onPress: (e)=>{
                    E(!1), h(e);
                },
                disableScroll: !0,
                children: /* @__PURE__ */ r(Qe, {
                    children: /* @__PURE__ */ r("ul", {
                        style: Je({
                            [C.top]: a.top ? `${a.top}px` : "",
                            [C.left]: a.left ? `${a.left}px` : "",
                            [C.maxHeight]: a.maxHeight ? `${a.maxHeight}px` : "",
                            [C.minWidth]: a.minWidth ? `${a.minWidth}px` : "",
                            [C.transformOrigin]: (_a_transformOrigin = a.transformOrigin) !== null && _a_transformOrigin !== void 0 ? _a_transformOrigin : ""
                        }),
                        onPointerDown: h,
                        className: ee(Ke, z ? se.show : se.hide),
                        role: "listbox",
                        ref: T,
                        children: u.map((param)=>/* @__PURE__ */ {
                            let { value: e , text: t  } = param;
                            return r("li", {
                                role: "option",
                                "aria-selected": e === (p !== null && p !== void 0 ? p : l),
                                "data-value": e,
                                className: ee(Ue, {
                                    [Xe]: e === v || e === (p !== null && p !== void 0 ? p : l)
                                }),
                                onPointerDown: h,
                                onClick: ()=>Q(e),
                                ref: (n)=>{
                                    n ? N.current.set(e, n) : N.current.delete(e);
                                },
                                children: /* @__PURE__ */ r(Le, {
                                    regular: !0,
                                    children: t
                                })
                            }, e);
                        })
                    })
                })
            })
        ]
    });
}, St = Ye;
export { St as default };
